import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingCardComponent } from '@shared/components/loading-card/loading-card.component';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LoaderService {
	private isOpen = new BehaviorSubject(false);

	constructor(private modalService: NgbModal) {}

	public show(): void {
		if (!this.isOpen.value) {
			this.isOpen.next(true);
			const loaderModal = this.modalService.open(LoadingCardComponent, {
				centered: true,
				backdrop: 'static',
				keyboard: false,
				ariaLabelledBy: 'loading-title'
			});
			loaderModal.componentInstance.showSpacing = true;
		}
	}

	public hide(): void {
		this.isOpen.next(false);
		this.modalService.dismissAll();

		// This is needed for accessibility after the loader is dismissed.
		// If focus has been lost after loader is hidden, main heading is focused.
		setTimeout(() => {
			const title = document.querySelector('h1, legend');
			if (title) {
				title.setAttribute('tabindex', '0');
				(title as HTMLElement).focus();
			}
		}, 500);
	}
}
